import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

export default defineStore("user", () => {
  const selectedVendor = useLocalStorage("vendor");
  const user = ref(null);
  const userExists = computed(() => user.value != null);
  const vendor = computed(() => user.value?.vendor?.label);
  const vendorOptions = ref([]);
  const isMirusUser = computed(() => user.value?.user_type === "mirus");
  const loadingUser = ref(false);
  const vendorKey = computed(() => {
    if (isMirusUser.value) {
      return selectedVendor.value ? selectedVendor.value : "all";
    }
    return user.value?.vendor?.key;
  });

  async function getUser() {
    loadingUser.value = true;
    try {
      const response = await fetch("/api/users/auth_info/");

      if (!response.ok) {
        throw new Error("failed to get user data");
      }

      user.value = await response.json();
    } finally {
      loadingUser.value = false;
    }
  }

  async function getVendorOptions() {
    const response = await fetch(`/api/vendors/`);
    if (!response.ok) {
      throw new Error("Failed to get vendors");
    }
    vendorOptions.value = await response.json();
  }

  async function ensureVendorOptions() {
    if (vendorOptions.length) {
      return;
    }
    await getVendorOptions();
  }

  async function ensureUser() {
    if (userExists.value) {
      return;
    }

    await getUser();
  }

  async function reset() {
    user.value = null;
  }

  return {
    user,
    userExists,
    vendor,
    vendorKey,
    vendorOptions,
    isMirusUser,
    loadingUser,
    getUser,
    ensureUser,
    getVendorOptions,
    ensureVendorOptions,
    reset,
  };
});
